<template>
    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Prozessmodell herunterladen
            <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>Wie wollen Sie das Prozessmodell herunterladen?</v-card-text>
        <v-card-actions>
          <v-btn outlined color="primary" text @click="optionSelected('PDF')">PDF-Datei</v-btn>
          <v-btn outlined color="primary" text @click="optionSelected('XML')">BPMN-Datei</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null
    };
  },
  methods: {
    optionSelected(option) {
      this.resolve(option);
      this.dialog = false;
    },
    open() {

        this.dialog = true;
        return new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
        },
  },
};
</script>

<style scoped>
.v-card-actions {
  justify-content: flex-end;
}
</style>
